<page-grid
  [gridConfig]="reconciliationGrid"
  (gridEvent)="uploadFileDialog()"
  (gridClickColumn)="handleGridAction($event)">
  <ng-template #actionItem let-item="item">
    <button mat-icon-button aria-label="edit payment reconciliation" (click)="openEditModal(item)">
      <mat-icon fontIcon="edit" />
    </button>
  </ng-template>
</page-grid>
